var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-white rounded-lg overflow-hidden my-2 mx-4 w-[calc(100%-2rem)]",
    },
    _vm._l(_vm.products, function (product, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass:
            "flex justify-between items-center p-3 border-b border-gray-100 last:border-b-0",
        },
        [
          _c("div", { staticClass: "flex items-center flex-1" }, [
            _c("div", { staticClass: "relative mr-3" }, [
              _c(
                "div",
                {
                  staticClass:
                    "absolute -top-1 -right-1 bg-orange-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold z-10",
                },
                [_vm._v(" " + _vm._s(product.count) + " ")]
              ),
              _c("img", {
                staticClass: "w-10 h-10 rounded-lg",
                attrs: { src: product.picUrl, alt: "" },
              }),
            ]),
            _c("div", { staticClass: "flex-1" }, [
              _c(
                "h3",
                { staticClass: "text-sm font-medium text-gray-800 mb-1" },
                [_vm._v(_vm._s(_vm.isZh ? product.region : product.regionEn))]
              ),
              _c("p", { staticClass: "text-xs text-gray-600 m-0" }, [
                _vm._v(
                  _vm._s(
                    _vm.isZh
                      ? product.selectedText +
                          (product.day > 1
                            ? _vm.$t("products.days")
                            : _vm.$t("products.day"))
                      : product.selectedTextEn +
                          (product.day > 1
                            ? _vm.$t("products.days")
                            : _vm.$t("products.day"))
                  )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "text-right" }, [
            product.marketPrice
              ? _c(
                  "div",
                  { staticClass: "text-xs text-gray-400 line-through mb-0.5" },
                  [
                    _vm._v(
                      "RM " + _vm._s(_vm.formatToYuan(product.marketPrice))
                    ),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "text-base font-bold text-gray-800" }, [
              _vm._v("RM " + _vm._s(_vm.formatToYuan(product.price))),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }